import React, { FC, SVGProps } from 'react';

const OpPlusGuaranteeIcon: FC<SVGProps<SVGSVGElement>> = ({ className }) => {
  return (
    <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle cx="31" cy="31" r="31" fill="#C6E2E6" />
      <g clipPath="url(#clip0_508_66433)">
        <path
          d="M16.683 21.2676C19.4689 17.2602 23.9515 14.4939 29.1048 14.0082C29.6436 13.9543 30.1968 13.9287 30.7528 13.9287C31.4091 13.9287 32.054 13.9656 32.6874 14.0395C38.8955 14.7325 44.0975 18.7285 46.4535 24.2157C47.041 25.5846 47.0725 26.1328 47.2732 27.6579"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.646 33.1395C47.1301 36.8998 45.3589 40.2625 42.7765 42.813C42.1574 43.4207 41.4867 43.9916 40.7788 44.4972L40.7673 44.5028C40.6384 44.5966 40.518 44.6875 40.389 44.7727L40.3833 44.7783C39.7499 45.2072 39.0763 45.5963 38.3856 45.9456C36.0898 47.0874 33.4988 47.7264 30.7531 47.7264C28.2653 47.7264 25.9036 47.1981 23.7712 46.2467C22.2149 45.5594 20.7876 44.642 19.5236 43.5486C15.9524 40.4471 13.6996 35.8972 13.6996 30.8276C13.6996 30.0039 13.7569 29.1945 13.8744 28.4078C14.0607 27.0985 14.29 26.7378 14.7658 25.5449"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.7448 14.1306L36.7803 22.0233C37.0898 22.6283 37.6831 23.0458 38.3624 23.1367L47.2101 24.3153C48.9212 24.5425 49.6262 26.6187 48.4024 27.8257L42.0769 34.0684C41.5896 34.5483 41.3747 35.2328 41.4979 35.9031L43.1001 44.6053C43.4096 46.2895 41.6383 47.5959 40.0992 46.8149L32.1515 42.7819C31.541 42.4723 30.8158 42.4808 30.2111 42.8018L22.3522 47.0023C20.8331 47.8146 19.0303 46.5479 19.3055 44.858L20.7213 36.1218C20.8303 35.4515 20.5981 34.7699 20.1023 34.3012L13.6477 28.1921C12.3981 27.0106 13.0573 24.9203 14.7655 24.6561L23.5875 23.29C24.2639 23.1849 24.8486 22.7561 25.1438 22.1426L29.0073 14.1704C29.7554 12.6282 31.9652 12.6026 32.7448 14.1306Z"
          fill="white"
        />
        <path
          d="M35.0553 23.3411L31.5446 15.7737C31.3667 15.3973 30.9206 15.2377 30.5474 15.4173C30.387 15.4943 30.2587 15.6254 30.1858 15.788L26.506 24.1908C26.2669 24.7325 25.7741 25.1089 25.2026 25.1802L16.1197 26.3008C15.7085 26.3492 15.4169 26.7256 15.4665 27.1391C15.4898 27.3215 15.5773 27.4898 15.7144 27.6124L22.5083 33.717C22.9545 34.1191 23.1615 34.7378 23.0449 35.3394L21.3128 44.3211C21.2312 44.7288 21.4965 45.1252 21.9018 45.2079C22.0826 45.2449 22.2692 45.2136 22.4267 45.1195L30.3374 40.4832C30.8302 40.1952 31.4338 40.1867 31.9324 40.4661L39.9423 44.937C40.0531 44.9997 40.1785 45.0311 40.3039 45.0311C40.7179 45.0311 41.0533 44.6975 41.0562 44.2812C41.0562 44.227 41.0503 44.1728 41.0387 44.1187L39.1113 35.1741C38.983 34.5753 39.1725 33.9509 39.6128 33.5403L46.2727 27.293C46.5759 27.0107 46.5934 26.5346 46.3135 26.2266C46.1881 26.0926 46.019 26.0071 45.8382 25.9871L42.9806 25.6963"
          stroke="#00909A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9981 33.5148C31.0124 34.8156 30.081 36.0454 28.1377 36.0653C26.9425 36.0767 25.6471 35.6705 25.0108 34.1936L26.4524 33.4012C26.7133 34.117 27.2492 34.6367 28.1349 34.6282C28.9402 34.6197 29.4418 34.1936 29.4332 33.4978C29.4246 32.677 28.7883 32.3305 27.8224 32.3419L26.7276 32.3532L26.7133 30.9843L27.8081 30.9729C28.6364 30.9644 29.1753 30.6832 29.1667 30.0357C29.1609 29.4875 28.7425 29.1496 28.0747 29.1581C27.3037 29.1666 26.8709 29.6153 26.6473 30.189L25.1885 29.4279C25.7502 28.1441 26.9425 27.7323 28.046 27.721C29.8287 27.7011 30.7172 28.8087 30.7287 29.9846C30.7373 30.6804 30.4192 31.2541 29.9176 31.612C30.5653 32.0039 30.9866 32.66 30.9981 33.5148Z"
          fill="#00909A"
        />
        <path
          d="M31.6029 31.8532C31.5771 29.4817 32.4799 27.6697 34.618 27.6469C36.759 27.6242 37.6991 29.4163 37.7249 31.7879C37.7507 34.1026 36.8479 35.9714 34.7097 35.9941C32.5687 36.0168 31.6287 34.1679 31.6029 31.8532ZM36.1371 31.8049C36.1227 30.4132 35.7616 29.0727 34.6352 29.0841C33.5088 29.0954 33.1764 30.4445 33.1907 31.8361C33.205 33.2733 33.6006 34.5684 34.6925 34.557C35.7874 34.5456 36.1514 33.242 36.1371 31.8049Z"
          fill="#00909A"
        />
        <path
          d="M49.4799 36.2494L48.1586 32.2505L44.7679 34.7867"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.8675 17.1011L16.565 21.3018L20.6664 20.2492"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_508_66433">
          <rect width="36.91" height="35.1524" fill="white" transform="translate(13 14)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OpPlusGuaranteeIcon;
